import React from 'react'
import Select from 'react-select'
import axios from 'axios'
import {getToken} from '../../../storage'
import {API_BASE_URL} from '../../../constants'

export class SeriesCounter extends React.Component {
  constructor(props){
    super(props)
    this.handleChange = this.handleChange.bind(this)
  }

  handleChange(e) {
    let value = e.target.value
    this.props.modifyItemState('series_counter', value)
  }

  render() {
    return <input type="text" className="form-control"  onChange={this.handleChange} value={this.props.series_counter} />
  }

}

export default class Series extends React.Component {

  constructor(props) {
    super(props)
    this.getItems = this.getItems.bind(this)
    this.handleChange = this.handleChange.bind(this)
    this.state = {}
  }

  handleChange(option) {

    if(option !== null) {
    this.props.onChangeCallback(option.series_name)
    }
    else {
      this.props.onChangeCallback("")
    }

  }

  getItems (input) {
    if (!input) {
       return   axios({
            url: '/list_invoice_series/',
            method: 'get',
            baseURL: API_BASE_URL,
            headers: {
              common: {
                'Authorization': 'Token ' + getToken()
              }
            }
          }).then((response)=> {
            this.setState({last_series_used: response.data.last_series_used})

            if(typeof this.props.option === "undefined" ||
            typeof this.props.option.series_name === "undefined" || this.props.option.series_name ===null ) {
              this.props.onChangeCallback(response.data.last_series_used)
            }

            return {options: response.data.invoicesseries}
          }).catch((err)=> {
            console.log(err);
            return Promise.resolve({ options: [] });
          })
    }
    return   axios({
        url: '/list_invoice_series/?q='+input,
        method: 'get',
        baseURL: API_BASE_URL,
        headers: {
          common: {
            'Authorization': 'Token ' + getToken()
          }
        }
      }).then((response)=> {
            return {options: response.data.invoicesseries}
      }).catch((err)=> {
        console.log(err);
        return Promise.resolve({ options: [] });
      })
}


  render() {

    let inputValue = this.props.option
    let optionSeriesName = inputValue.series_name
    if(typeof optionSeriesName === "undefined" && typeof this.state.last_series_used !== "undefined") {
       inputValue = {series_name:this.state.last_series_used}
    }
    return   <div><Select.Async name="series_name" className="" value={inputValue}

        valueKey="series_name" labelKey="series_name" loadOptions={this.getItems} onChange={this.handleChange}  />

        </div>

  }
}



// WEBPACK FOOTER //
// ./src/components/invoice/rowelements/series.js